import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '~/hooks/useAuth';

import DefaultThemeMode from './Customization/ThemeMode';
import FullScreen from './FullScreen';

const HeaderContent = ({ disableCTAs }: { disableCTAs: boolean }) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
  const themeMode = useMemo(() => <DefaultThemeMode />, []);
  const { user, requires2FA } = useAuth();

  useEffect(() => {
    // Show modal if user is admin without 2FA
    // Skip check if Cognito is enabled (Cognito handles 2FA)
    const isUsingCognito = (user as any)?.cognitoSub;
    if (
      user &&
      user.role !== 'enduser' &&
      !user.twoFactorEnabled &&
      (process.env.ENVIRO === 'production' || process.env.ENVIRO === 'prod') &&
      !isUsingCognito
    ) {
      setShowModal(true);
    }
  }, [user, requires2FA]);

  const handleEnableClick = () => {
    navigate('/dashboard/admin/profile/details?tab=settings');
    setShowModal(false);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const newCombineUrl = 'new-v2?step=Account';

  return (
    <>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
          <Box sx={{ display: 'flex', width: '100%', justifyContent: 'end' }}>
            {themeMode}
            <Box sx={{ mr: 1 }}>{!downLG && <FullScreen />}</Box>
            {user?.role === 'enduser' && (
              <Button
                variant="contained"
                onClick={(e: any) => {
                  e.stopPropagation();
                  navigate(`/dashboard/accounts/${newCombineUrl}`);
                }}
                disabled={disableCTAs ?? false}
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: '10px', sm: '14px' },
                  fontFamily: 'Roboto Condensed',
                  mr: 3,
                }}
              >
                START A TRADING COMBINE
              </Button>
            )}
          </Box>
        </Box>
        <Dialog
          open={showModal}
          onClose={handleClose}
          aria-labelledby="2fa-dialog-title"
          aria-describedby="2fa-dialog-description"
        >
          <DialogTitle id="2fa-dialog-title">Two-Factor Authentication Required</DialogTitle>
          <DialogContent>
            <DialogContentText id="2fa-dialog-description">
              To access the admin panel, you need to enable Two-Factor Authentication (2FA). This
              additional security measure helps protect your account and sensitive information.{' '}
              <br /> <br />
              Without this enabled, your access will be very limited.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary" variant="contained">
              Later
            </Button>
            <Button onClick={handleEnableClick} variant="contained" color="primary" autoFocus>
              Enable 2FA Now
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default HeaderContent;
